// Utilities
import { makeStyles, tokens } from "@fluentui/react-components";
import { flexChildSizeFixed, flexParent, styleScrollbar } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
// Constants
import { LeftNavMaxWidth, LeftNavMinWidth } from "@ms/uno-constants/lib/local/EvoLeftNavConstants";
/**
 * Left Nav Style constants
 */ export const rowIconTextSpacing = tokens.spacingHorizontalS;
export const rowEdgeToContentSpacing = tokens.spacingHorizontalXXS;
/**
 * Styles for LeftNav component
 */ export const useLeftNavStyles = makeStyles({
    root: {
        ...flexParent("column"),
        width: "100%",
        maxWidth: LeftNavMaxWidth,
        backgroundColor: tokens.colorNeutralBackground2,
        borderRight: `1px solid ${tokens.colorNeutralStroke2}`,
        height: "100%",
        overflow: "hidden",
        minHeight: "0"
    },
    collapsed: {
        maxWidth: LeftNavMinWidth,
        backgroundColor: tokens.colorNeutralBackground1,
        borderRight: "none"
    },
    appHeader: {
        ...flexParent("row"),
        ...flexChildSizeFixed("28px"),
        height: "28px",
        backgroundColor: tokens.colorNeutralBackground2,
        gap: tokens.spacingHorizontalMNudge,
        padding: "15px 18px 15px 22px",
        alignItems: "center",
        boxSizing: "content-box"
    },
    appHeaderCollapsed: {
        padding: "15px 18px 15px 18px",
        borderRightStyle: "hidden",
        borderBottom: `1px solid ${tokens.colorNeutralStroke3}`,
        justifyContent: "flex-start",
        backgroundColor: tokens.colorNeutralBackground1
    },
    appLogo: {
        width: tokens.spacingHorizontalXL,
        height: tokens.spacingHorizontalXL
    },
    appHeaderTitle: {
        fontSize: "18px",
        fontWeight: tokens.fontWeightBold,
        lineHeight: "28px",
        margin: "0",
        color: tokens.colorNeutralForeground1,
        verticalAlign: "middle"
    },
    toggleButton: {
        cursor: "pointer",
        minWidth: tokens.spacingHorizontalXL,
        width: tokens.spacingHorizontalXL,
        height: "28px",
        color: tokens.colorNeutralForeground2,
        border: "none",
        backgroundColor: "transparent",
        boxShadow: "none",
        borderRadius: tokens.borderRadiusMedium,
        padding: tokens.spacingHorizontalNone,
        ":hover, :active": {
            color: tokens.colorBrandForeground1
        }
    },
    // Styles for toggle button when showing app info (expanded state)
    toggleButtonWithAppInfo: {
        marginLeft: "auto"
    },
    // Styles for toggle button when NOT showing app info (collapsed state)
    toggleButtonWithoutAppInfo: {
        marginRight: "auto"
    },
    // RTL (Right-to-Left) support for toggle button
    toggleButtonRTL: {
        transform: "scaleX(-1)"
    },
    leftNavContent: {
        ...flexParent("column"),
        flex: "1 1 0%",
        minHeight: 0,
        overflow: "hidden"
    },
    // Scrollable area below the sticky "Create a plan" button.
    // Contains the view dropdown, static section, and pinned section.
    scrollableSection: {
        ...flexParent("column"),
        ...styleScrollbar,
        flex: "1 1 0%",
        overflowY: "auto",
        overflowX: "hidden",
        minHeight: 0
    },
    newPlanSection: {
        marginTop: tokens.spacingVerticalXL,
        flexShrink: 0
    }
});
